'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _TableCell = require('./TableCell.style');

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TableCell = (_dec = (0, _reactJss2["default"])(_TableCell2["default"]), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3["default"])(TableCell, _PureComponent);

  function TableCell(props) {
    (0, _classCallCheck3["default"])(this, TableCell);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (TableCell.__proto__ || (0, _getPrototypeOf2["default"])(TableCell)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3["default"])(TableCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          classes = _props.classes,
          visibility = _props.visibility,
          children = _props.children,
          width = _props.width;
      var scrolled = this.context.scrolled;
      var style = {
        flexGrow: width === 'auto' ? 1 : 0,
        minWidth: scrolled ? width + 'px' : 0,
        width: width === 'auto' ? '200px' : width + 'px'
      };
      if (width !== 'auto') style.padding = 0;
      return _react2["default"].createElement('div', {
        className: (0, _clsx2["default"])(classes.tableCell, className, {
          hidden: visibility === 'hidden'
        }, {
          disabled: visibility === 'disabled'
        }, 'scTableCell', {
          ellipsis: typeof children === 'string'
        }),
        style: style
      }, children);
    }
  }]);
  return TableCell;
}(_react.PureComponent), _class2.contextTypes = {
  scrolled: _propTypes2["default"].bool.isRequired
}, _temp)) || _class);
TableCell.defaultProps = {
  visibility: 'visible',
  width: '200'
};
TableCell.propTypes = {
  /** React-JSS injects a classes, which is a simple map of rule names and generated class names */
  classes: _propTypes2["default"].object,

  /** additional class name */
  className: _propTypes2["default"].string,

  /** table's visibility */
  visibility: _propTypes2["default"].oneOf(['visible', 'disabled', 'hidden']),

  /** table's Content */
  children: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]),

  /** table's Cell Content */
  width: _propTypes2["default"].string
};
exports["default"] = TableCell;